import AuthService from '../services/AuthService'

/**
 * Il biglietto per entrare nella VM assegnata.
 *
 * La dashboard leggeva il cookie di sessione e lo passava alla VM. Ora quel
 * cookie e' HttpOnly: da JavaScript non si vede piu'. Il token lo chiede il
 * backend, che la sessione ce l'ha davvero, e vive giusto il tempo del
 * passaggio — non viene mai messo da parte da questa parte.
 *
 * Va nel FRAGMENT (#) e non nella query: il frammento non viene inviato al
 * server, quindi non finisce negli access log di nginx ne' nel Referer.
 */
export const handoffUrl = async (assignedVm) => {
  const response = await AuthService.refreshToken()
  const token = response?.data?.access_token
  if (!token) {
    throw new Error('handoff: il backend non ha rilasciato un token')
  }
  const base = assignedVm.replace(/\/+$/, '')
  return `${base}/oauth-callback#token=${encodeURIComponent(token)}`
}
